{
  "id": "ptah",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Ptah",
    "en": "Ptah"
  },
  "icon": "gods/ptah",
  "portrait": "gods/ptah-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "wadjet": 1
  },
  "unlocks": ["wadjet", "shaduf", "scalloped-axe", "leather-frame-shield", "electrum-bullets"],
  "powers": ["shifting-sands"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "God of innovation. Focus: technology. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 180 s."
  }
}
